S.toggle = {

    config: {
        // group: gruppe für accordion
        group: null,

        // clickHead false verhindert klicken auf aktiven toggle
        clickHead: true,

        // name der transitionClass
        transitionClass: 'has-transitions',

        // Verzögerung zum setzen der transitionClass
        settransitionsDelay: 500,

        // toggle only
        // öffnet bei resize geschlossene Toggles
        // z.B. is-toggle-closed-mobile is-toggle-closed-tablet
        resizeOpen: false,

        // toggle wird z.B. bei tablet destroyed
        destroyFrom: null,

        // classname aller Module bei denen destroyFrom wirken soll
        // siehe sz media
        modulesClassName: null,

        // geöffnete toogle initial schließen
        initCloseFrom: null,
    },

    elements: {
        $toggleHead: null,
        $toggleContent: null,
    },

    /**
     Achtung: Sollte ein Parentelement des Moduls welches den Toggle verwendet bereits eine feste Höhe haben
     (durch ein anderes Javascript. etc.) muss im Script des Moduls diese Höhe mit angeglichen werden. Bsp.
     ADAC camping Modul detail-service:
     setToggleHeightMobile()
     {
     var $toggleHead = this.elements.$toggleHead;
     var mainContent = $('.lay-main-content');

     $toggleHead.on('click', function()
     {
     //reset lay-main-content height for Mobile screens
     if (!S.mq('tablet', false).matches)
     {
     if($(this).next().outerHeight() > 0)
     {
     let newHeight = mainContent.height() - $(this).next().outerHeight();
     mainContent.height(newHeight);
     }
     else
     {
     S.delayed('resizeHeight', 1500, () => {
     let newHeight = mainContent.height() + $(this).next().outerHeight();
     mainContent.height(newHeight);
     });
     }
     }
     });
     },
     */

    initOrDestroy(mq)
    {
        var $toggleHead = this.elements.$toggleHead;
        var modulesClassName = this.config.modulesClassName;
        var $module = this.$module;

        if (mq.matches)
        {
            // auf tablet/desktop
            // console.log('destroy');

            // this.$module.removeClass('is-toggle-open');
            // this.$module.removeClass('is-toggle-closed');
            $('.' + modulesClassName).addClass('is-toggle-open');
            $('.' + modulesClassName).removeClass('is-toggle-closed');
            $module.find('.m-content').css('opacity', 1);
            $module.find('.m-content').css('max-height', '99999px');

            // unbind
            $toggleHead.unbind('click');
        }
        else
        {
            // console.log('init');
            // e.g. mobile
            this.toggleInit();
            this.toggleKeyTab();
            this.toggleOpenClose();
            this.responsiveClose();
            this.resize();
        }
    },

    start()
    {
        // console.log('start');
    },

    init()
    {
        /*
        let accordion = this.$module.hasClass('is-accordion');

        if (accordion===true) {
            this.config.group = 'accordion';
        }
        */
        // NEW group ist set in accordion
        this.config.group = this.$module.attr('data-group');
        const destroyFrom = this.config.destroyFrom;
        const initCloseFrom = this.config.initCloseFrom;

        /*
        if (S.mq('tablet').matches)
        {
           return;
        }
        */

        if (destroyFrom === null)
        {
            this.toggleInit();
            this.toggleKeyTab();
            this.toggleOpenClose();
            this.responsiveClose();
            this.resize();
        }
        else
        {
            const mq = S.mq(destroyFrom);

            mq.addListener(this.initOrDestroy.bind(this));
            this.initOrDestroy(mq);
        }

        if (initCloseFrom !== null)
        {
            const mqClose = S.mq(initCloseFrom);

            this.$module.removeClass('is-toggle-open');
            this.$module.addClass('is-toggle-closed');
            if (mqClose.matches)
            {
                setTimeout(function ()
                {
                    // enable & start transition
                    S.toggle.addTransitions();
                    this.elements.$toggleContent.css({'max-height': 0, opacity: 0});
                }, 25);
            }
        }

        // var toggle = $module.children('*:first-child');
        // var content = $module.children('*:last-child');
    },

    toggleInit()
    {
        const $module = this.$module;
        const group = this.config.group;
        const settransitionsDelay = this.config.settransitionsDelay;
        const $toggleHead = this.elements.$toggleHead;
        const $toggleContent = this.elements.$toggleContent;
        let height = 0;

        // toggle mit tab ansteuern
        // $toggleHead.attr('tabindex', 0);

        // remove init closed class - geschlossener toggle = default
        if (!$module.hasClass('is-toggle-open'))
        {
            if (group)
            {
                height = this.setAccordionTabsHeight($module);
                // alert(height);
            }

            // Tabs set height 99999 ignore slideup!;
            setTimeout(function ()
            {
                $toggleContent.css({'max-height': height, opacity: 0});
                $module.addClass('is-toggle-closed');
            }, 25);
            setTimeout(function ()
            {
                S.toggle.addTransitions();
            }, settransitionsDelay);


            // allen geschlossenen Tabs im Content tabindex -1 zuweisen um direkt zum nächsten Klapper zu springen
            $toggleContent.find('a, button, input, select, label').attr('tabindex', '-1');
        }
        else if (group)
        {
            const height = $toggleContent[0].scrollHeight;

            S.toggle.addTransitions();
            $toggleContent.css({'max-height': height, opacity: 1});
        }
        else
        {
            S.toggle.addTransitions();
            $toggleHead.attr('aria-expanded', true);
            $toggleContent.attr('aria-hidden', false);
        }
    },

    toggleKeyTabEscape(element)
    {
        setTimeout(function ()
        {
            element.click();
        }, 15);

        setTimeout(function ()
        {
            $('body').addClass('is-keyboard-focus');
            element.focus();
        }, 25);
    },

    toggleKeyTab()
    {
        const $toggleHead = this.elements.$toggleHead;

        // Keysteuerung
        $toggleHead.on('keydown', (e) =>
        {
            // elements.$toggleContent.find('a').attr('tabindex', '-1');
            // leer oder return
            if (e.keyCode === 13 || e.which === 32)
            {
                // $(e.currentTarget).addClass('is-key-focus');
                // $toggleHead.click();

                setTimeout(function ()
                {
                    $('body').addClass('is-keyboard-focus');
                    $(e.currentTarget).focus();
                }, 25);
            }

            // escape
            else if (e.keyCode === 27)
            {
                this.toggleKeyTabEscape($(e.currentTarget));
            }
        });

        // check QS
        // Keysteuerung escape
        $('.js-toggle-content a').on('keydown', (e) =>
        {
            // const actHead = this.$module.find('.js-toggle-head');
            const actContent = $(e.currentTarget).closest('.js-toggle');
            const actHead = actContent.find('.js-toggle-head');

            if (e.keyCode === 27)
            {
                this.toggleKeyTabEscape(actHead);
            }
        });
    },

    toggleOpenClose()
    {
        const $module = this.$module;
        const group = this.config.group;
        let clickHead = this.config.clickHead;
        const transitionClass = this.config.transitionClass;
        const $toggleHead = this.elements.$toggleHead;
        const $toggleContent = this.elements.$toggleContent;
        const validhash = window.location.hash;
        const moduleId = $module.attr('id');

        // open using hashtag
        if (moduleId && validhash.indexOf('=') === -1)
        {
            if ('#' + moduleId === validhash + '_open' || '#' + moduleId === validhash)
            {
                setTimeout(function ()
                {
                    $toggleHead.click();
                }, 200);
            }

            // var hashTagToggle = $(validhash + '.js-toggle');
            // var hashTagToggleOpen = $(validhash + '_open.js-toggle');
            //
            // if ((hashTagToggle.length || hashTagToggleOpen.length) && !hashTagToggle.hasClass('is-toggle-open'))
            // {
            //     setTimeout(function ()
            //     {
            //         hashTagToggleOpen.click();
            //     }, 150);
            // }
        }

        // click or touchstart
        // var event = this.getClickEvent();

        // css transition callback
        $toggleContent.on('transitionEnd webkitTransitionEnd transitionend oTransitionEnd msTransitionEnd', () =>
        {
            // if (!$module.attr('data-toggle-group') && $module.hasClass('is-toggle-open'))
            if (!group && $module.hasClass('is-toggle-open'))
            {
                $toggleContent.css('max-height', 99999);
            }
        });

        $toggleHead.on('click', () =>
        {
            // verhindert schließen von geöffnetem Tab
            if ($module.parent().hasClass('js-tabs-content'))
            {
                clickHead = false;
            }

            // bei Klick auf geöffnetem accordion passiert nichts
            // nur bei geschlossenen werden die anderen überprüft und gf geschlossen
            // if (config.clickActiveAccordion === false || ($module.attr('data-toggle-group') && $module.hasClass('is-toggle-closed')))
            if (group && (clickHead === false || $module.hasClass('is-toggle-closed')))
            {
                // setAccordionHeight($module.data('toggle-group'));
                S.toggle.setAccordionHeight(group);
            }

            $module.toggleClass('is-toggle-open is-toggle-closed');

            const height = $toggleContent[0].scrollHeight;

            if ($module.hasClass('is-toggle-closed'))
            {
                // disable transitions & set max-height to content height
                $toggleContent.removeClass(transitionClass).css('max-height', height);

                // 20ms timeout is the secret ingredient for disabling/enabling transitions
                setTimeout(function ()
                {
                    // enable & start transition
                    S.toggle.addTransitions();
                    $toggleContent.css({'max-height': 0, opacity: 0});
                }, 25);

                $toggleContent.find('a, button, input, select, label').attr('tabindex', '-1');
                $toggleHead.attr('aria-expanded', false);
                $toggleContent.attr('aria-hidden', true);


                // allen geschlossenen Tabs im Content tabindex -1 zuweisen um direkt zum nächsten Klapper zu springen
                // elements.$toggleContent.find('a').attr('tabindex', '-1');
            }
            else if ($module.hasClass('is-toggle-open'))
            {
                $toggleContent.css({'max-height': height, opacity: 1});
                $toggleHead.attr('aria-expanded', true);
                $toggleContent.attr('aria-hidden', false);

                /*
                window.setTimeout(function ()
                {
                    $toggleContent.css({'max-height': 'inherit'});
                }, 500);
                */

                /*
                contentTable = $toggleContent.find('.mod-accordion');
                if (contentTable.length > 0)
                {

                    newHeight = contentTable[0].scrollHeight;
                    if (newHeight > height)
                    {
                        $toggleContent.css({'max-height': newHeight});
                        window.setTimeout(function ()
                        {
                            $toggleContent.css({'max-height': newHeight});
                        }, 100);
                    }
                }
                */

                // console.log($(window).scrollTop()+':'+$('#pp').offset().top);
                // move up to toggler if the content is very long
                // only accordion
                if (group && $toggleHead.parent().parent().hasClass('js-group-set-top'))
                {
                    const top = $toggleHead.parent().parent().position().top - 60;

                    if ($(window).scrollTop() > 0 && ($(window).scrollTop() > top))
                    {
                        // var top = e.pageY - $(window).scrollTop();
                        $('html').animate({
                            scrollTop: top,

                            // scrollTop: 100,
                        }, 250);
                    }
                }

                $toggleContent.find('a, button, input, select, label').removeAttr('tabindex');
            }
        });
    },

    // getClickEvent()
    // {
    //     // click or touchstart
    //     var event = 'click';
    //
    //     // Touch Device Detection
    //     var touchDevice = 'ontouchstart' in document.documentElement;
    //
    //     if (touchDevice)
    //     {
    //         event = 'touchstart';
    //     }
    //
    //     return event;
    // },

    // isTabModus
    isTabModus()
    {
        var $module = this.$module;

        if ($module.parent().hasClass('js-tabs-content') && (S.mq($module.parent().parent().module('tabs').config.tabsfrom, false).matches))
        {
            return true;
        }

        return false;
    },

    // setAccordionTabsHeight
    setAccordionTabsHeight(module)
    {
        // if (this.$module.parent().hasClass('js-tabs-content')) {
        if (S.toggle.isTabModus(module))
        {
            // alert('99999');
            return 99999;
        }

        return 0;
    },

    // resizeAccordion
    resizeAccordion()
    {
        var $module = this.$module;
        var group = this.config.group;
        var $toggleContent = this.elements.$toggleContent;
        var that = this;

        // if ($(this).hasClass('is-toggle-open') && $(this).attr('data-toggle-group'))
        if (that.config.group && $module.hasClass('is-toggle-open'))
        {
            const height = ($toggleContent[0].scrollHeight);

            $toggleContent.css('max-height', height + 'px');
        }
        else if (group)
        {
            $toggleContent.css('max-height', this.setAccordionTabsHeight());
        }
    },

    // setAccordionHeight
    setAccordionHeight(actGroup)
    {
        $(this.instances).each(function ()
        {
            var $module = this.$module;
            var $toggleContent = this.elements.$toggleContent;
            var $toggleHead = this.elements.$toggleHead;
            var transitionClass = this.config.transitionClass;
            var group = this.config.group;

            // jquery object: this.$module
            if ((group === actGroup) && $module.hasClass('is-toggle-open'))
            {
                // if (configInstanceGroup !== null && configInstanceGroup === group && $(this).hasClass('is-toggle-open'))
                // alert(setAccordionTabsHeight(this.$module));
                $module.toggleClass('is-toggle-open is-toggle-closed');
                $toggleContent.addClass(transitionClass).css({
                    'max-height': this.setAccordionTabsHeight($module),
                    opacity: 0,
                });

                // geschlossene accordions tab steuerung raus
                $toggleContent.find('a, button, input, select, label').attr('tabindex', '-1');
                $toggleHead.attr('aria-expanded', false);
                $toggleContent.attr('aria-hidden', true);
            }
        });
    },

    // addTransitions
    addTransitions()
    {
        var transitionClass = this.config.transitionClass;
        var $toggleHead = this.elements.$toggleHead;
        var $toggleContent = this.elements.$toggleContent;

        $toggleContent.addClass(transitionClass);
        $toggleHead.addClass(transitionClass);
    },

    // responsiveClose
    responsiveClose()
    {

    },

    resize()
    {
        const group = this.config.group;
        const resizeOpen = this.config.resizeOpen;
        const $toggleContent = this.elements.$toggleContent;

        $(window).on('resize', () =>
        {
            // S.delayed('resizeAccordion', 200, () =>
            S.delayed('resizeAccordion' + this.instance, 200, () =>
            {
                S.toggle.resizeAccordion();

                if (!group && resizeOpen === true)
                {
                    const mq = S.mq(this.config.destroyFrom);

                    if (mq.matches && this.$module.hasClass('is-toggle-closed'))
                    {
                        const height = $toggleContent[0].scrollHeight;

                        this.$module.toggleClass('is-toggle-open is-toggle-closed');
                        $toggleContent.css({'max-height': height, opacity: 1});
                    }
                }
            });
        });
    },
};
